module.exports = __webpack_public_path__ + "img/cx.svg";